import JSZip from 'jszip'
import { uploadFile } from '@/api/common/upload'
import { Message } from 'element-ui'
import i18n from '@/lang'
import convertCocosModel from '../convert-cocos-model'

export interface modelState {
  loading: boolean
  fbxData: null | string
  lmData: null | string
  texData: null | string
  conversionFrame: null | HTMLIFrameElement
  texType: 'png' | 'jpg' | ''
}

const EVENT_TYPE = 'PLAYABLE:model2lm'

let ConversionCallBack: any = null

const modelModule = {
  namespaced: true,

  state: {
    loading: false,
    fbxData: null,
    lmData: null,
    texData: null,
    conversionFrame: null,
    texType: '',
  },

  mutations: {
    setConversionFrame(state: modelState, frame: HTMLIFrameElement) {
      state.conversionFrame = frame
    },

    setLoading(state: modelState, loading: boolean) {
      state.loading = loading
    },

    setFbxData(state: modelState, data: string) {
      state.fbxData = data
    },

    setLMData(state: modelState, data: string) {
      state.lmData = data
    },

    setTexData(state: modelState, data: string) {
      state.texData = data
    },

    setTexType(state: modelState, type: 'png' | 'jpg' | '') {
      state.texType = type
    },
  },

  actions: {
    convertCocosModel,
    dispatchConversionEvent(
      { commit, state, dispatch }: any,
      {
        texType,
        callback,
      }: {
        callback: (file: any) => void
        texType: 'png' | 'jpg' | ''
      },
    ) {
      // 如果当前已经在转换中，不允许重复转换
      if (state.loading) {
        return
      }

      if (ConversionCallBack) {
        window.removeEventListener('message', ConversionCallBack)
      }

      ConversionCallBack = (event: any) => {
        if (event.data.type === EVENT_TYPE) {
          if (event.data.data.type === 'progressState') {
            if (event.data.data.state === 0) {
              console.log('开始转换')
              commit('setLoading', true)
            } else {
              const message = i18n.t(
                `playTurbo.creative.validator.model.message${event.data.data.state}`,
              )
              console.log(event.data.data.state)
              Message.error(String(message))
              window.removeEventListener('message', ConversionCallBack)
              commit('setLoading', false)
            }
          } else if (event.data.data.type === 'modelData') {
            commit('setFbxData', event.data.data.fbx)
            commit('setLMData', event.data.data.lm)
            commit('setTexData', event.data.data.tex)
            dispatch('packBase64ToZip', {
              callback,
            })
          }
        }
      }
      window.addEventListener('message', ConversionCallBack)

      if (state.conversionFrame) {
        commit('setTexType', texType)
        state.conversionFrame.contentWindow.postMessage(
          {
            type: EVENT_TYPE,
            data: 'DispatchEvent',
            texType: state.texType,
          },
          '*',
        )
      }
    },

    packBase64ToZip(
      { commit, state }: any,
      {
        callback,
      }: {
        callback: (file: any) => void
      },
    ) {
      const zip = new JSZip()
      const zipFile = zip
        .file('model.lm', state.lmData, { base64: true })
        .file('model.FBX', state.fbxData, { base64: true })
      if (state.texData) {
        zipFile.file(`model.${state.texType}`, state.texData, { base64: true })
      }
      zipFile
        .generateAsync({ type: 'base64' })
        .then(async (content: string) => {
          // 获取到 zip 文件的 base64 后，上传到服务器
          const res = await uploadFile({
            file_base64: content,
            filename: 'model.zip',
            unzip: 1,
          })
          commit('setLoading', false)
          const file = res.data.data
          callback(file)
        })
    },
  },
}

export default modelModule
